<template>
  <div id="app">
    <MainNav></MainNav>
    <transition name="page-anim" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import MainNav from './components/MainNav.vue'

export default {
  name: 'app',
  components: {
    MainNav
  }
}
</script>

<style lang="scss">
	@import "./assets/scss/style.scss"
</style>